// Typography definitions for the app

export const typography = {
  // Font Families
  fonts: {
    primary: 'Inter_400Regular', // For body text, descriptions, general content
    secondary: 'Inter_700Bold', // For headings, titles, emphasis
  },

  // Font Weights - Use specific font family names for each weight
  weights: {
    light: '300',
    regular: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
  },

  // Font family by weight - Use these for specific font weights with Google Fonts
  fontFamilies: {
    inter: {
      light: 'Inter_300Light',
      regular: 'Inter_400Regular',
      medium: 'Inter_500Medium',
      semibold: 'Inter_600SemiBold',
      bold: 'Inter_700Bold',
    },
  },

  // Font Sizes
  sizes: {
    xs: 11,
    sm: 12,
    md: 13,
    base: 14,
    lg: 15,
    xl: 16,
    '2xl': 18,
    '3xl': 20,
    '4xl': 24,
    '5xl': 28,
    '6xl': 32,
  },

  // Line Heights
  lineHeights: {
    tight: 1.2,
    normal: 1.5,
    relaxed: 1.7,
  },
};

// Helper function to create text styles with proper font family for weight
export const createTextStyle = (
  fontFamily: 'primary' | 'secondary',
  size: keyof typeof typography.sizes,
  weight: keyof typeof typography.weights = 'regular'
) => {
  const fontFamilyName = typography.fontFamilies.inter[weight];
  
  return {
    fontFamily: fontFamilyName,
    fontSize: typography.sizes[size],
  };
};

export type Typography = typeof typography;
